export const isOutsideLaycan = (
  date?: Date,
  laycanStart?: Date,
  laycanEnd?: Date
) => {
  if (!date) {
    return false;
  }

  const time = new Date(date).setHours(0, 0, 0, 0);
  const start = laycanStart && new Date(laycanStart).setHours(0, 0, 0, 0);
  const end = laycanEnd && new Date(laycanEnd).setHours(0, 0, 0, 0);

  if (!!end && time > end) {
    return true;
  }

  if (!!start && time < start) {
    return true;
  }

  return false;
};
